import { api } from '../../services/api'
import { getVisitDateString } from '../../services/helpers'
import { showError, showSuccess } from '../misc/misc.actions'
import { VISIT_TYPE_DISPLAY_NAMES } from '../../utils'

export const postVisit = (payload, cb) => {
	return (dispatch) => {
		dispatch({ type: 'POST_VISIT' })

		return api
			.post(`/visit`, payload)
			.then((response) => {
				const date = getVisitDateString(response.data)
				const { type } = response.data
				const appointmentDateString = `${date ? `${date} ` : ''}${
					type && typeof type === 'string' ? VISIT_TYPE_DISPLAY_NAMES[type] : ''
				}`

				dispatch(
					showSuccess(
						`${
							appointmentDateString ? `${appointmentDateString} appointment ` : 'Appointment '
						}created successfully.`
					)
				)
				dispatch({ type: 'POST_VISIT_SUCCESS' })

				if (cb && typeof cb === 'function') {
					cb(response.data)
				}
			})
			.catch(() => {
				dispatch(showError('An error occured while creating this appointment.'))
				dispatch({ type: 'POST_VISIT_FAIL' })
			})
	}
}

/**
 * Same logic as updateVisit, but with async/await pattern
 * @param {function} dispatch - dispatch function from redux
 * @param {object} payload
 * @param {boolean} suppressLoad
 * @returns object | null
 */
export const updateVisitAsync = async (dispatch, payload, suppressLoad) => {
	if (!suppressLoad) {
		dispatch({ type: 'UPDATE_VISIT' })
	}
	try {
		const response = await api.patch(`/visits/${payload.visit_id}`, payload.updates)
		dispatch({
			type: 'UPDATE_FACILITY_SUCCESS',
			payload: { kennels: response.data.kennels }
		})
		dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: response.data })
		dispatch(showSuccess('Appointment updated successfully.'))
		return response
	} catch (e) {
		console.log(e)
		dispatch(
			showError(e?.data?.error || e?.data?.message || 'An error occured while updating this appointment.')
		)
		dispatch({
			type: 'UPDATE_VISIT_FAIL',
			payload: { message: e?.data?.error || e.message }
		})
		return null
	}
}

export const updatePetSurvey = async (dispatch, payload, suppressLoad) => {
	if (!suppressLoad) {
		dispatch({ type: 'UPDATE_VISIT' })
	}
	try {
		const response = await api.patch(`/pet/welcomeday/survey`, payload)

		dispatch({ type: 'STOP_VISIT_LOADING' })
		dispatch(showSuccess('Appointment updated successfully.'))
		return response
	} catch (e) {
		console.log(e)
		dispatch(showError('An error occured while updating this appointment.'))
		dispatch({
			type: 'UPDATE_VISIT_FAIL',
			payload: { message: e.message }
		})
		return null
	}
}

export const updateVisit = (payload, suppressLoad) => {
	return (dispatch) => {
		if (!suppressLoad) dispatch({ type: 'UPDATE_VISIT' })

		return api
			.patch(`/visits/${payload.visit_id}`, payload.updates)
			.then((response) => {
				dispatch({
					type: 'UPDATE_FACILITY_SUCCESS',
					payload: { kennels: response.data.kennels }
				})
				dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: response.data })
				dispatch(showSuccess('Appointment updated successfully.'))
			})
			.catch((e) => {
				console.log(e)
				dispatch(showError('An error occured while updating this appointment.'))
				dispatch({
					type: 'UPDATE_VISIT_FAIL',
					payload: { message: e.message }
				})
			})
	}
}

export const deleteVisit = (payload) => {
	return (dispatch) => {
		dispatch({ type: 'DELETE_VISIT' })

		return api
			.delete(`/visits/${payload.visit_id}`)
			.then((response) => {
				dispatch(showSuccess('Appointment deleted successfully.'))
				dispatch({ type: 'DELETE_VISIT_SUCCESS', payload: response.data })
			})
			.catch((e) => {
				dispatch(showError('An error occured while deleting this appointment.'))
				dispatch({
					type: 'DELETE_VISIT_FAIL',
					payload: { message: e.message }
				})
			})
	}
}

export const getVisitsByFacilityId = (facility, date) => {
	return (dispatch) => {
		dispatch({ type: 'GET_VISITS' })

		return api
			.get(`/facilities/${facility._id}/visits?date=${date}`)
			.then((res) => {
				dispatch({ type: 'SET_VISITS', payload: res.data })
			})
			.catch((error) => {
				dispatch({ type: 'GET_VISITS_FAIL', payload: error })
			})
	}
}

export const getVisitsByHouseholdIdAsync = async (dispatch, householdId, queryParams) => {
	dispatch({ type: 'GET_VISITS' })
	try {
		let url = `/households/${householdId}/visits`
		if (queryParams) {
			url += '?'
			Object.entries(queryParams).forEach(([key, value]) => {
				url += `${key}=${value}&`
			})
			url = url.slice(0, -1)
		}

		const response = await api.get(url)
		dispatch({ type: 'SET_VISITS', payload: response.data })
	} catch (e) {
		dispatch({ type: 'GET_VISITS_FAIL', payload: e })
	}
}

export const getTrainingEnrollmentsByHouseholdIdAsync = async (dispatch, householdId, queryParams) => {
	dispatch({ type: 'GET_TRAINING_ENROLLMENTS' })
	try {
		let url = `/households/${householdId}/training/enrollments`
		if (queryParams) {
			url += '?'
			Object.entries(queryParams).forEach(([key, value]) => {
				url += `${key}=${value}&`
			})
			url = url.slice(0, -1)
		}

		const response = await api.get(url)
		if (response.data?.data && response.data?.data.length) {
			const training_enrollments = response.data.data
			dispatch({ type: 'SET_TRAINING_ENROLLMENTS', payload: training_enrollments })
		}
	} catch (e) {
		console.log(e)
		dispatch({ type: 'GET_TRAINING_ENROLLMENTS_FAIL', payload: 'Failed to load training enrollments' })
	}
}

export const getVisitsByHouseholdId = (householdId) => {
	return (dispatch) => {
		dispatch({ type: 'GET_VISITS' })

		api.get(`/households/${householdId}/visits`)
			.then((res) => {
				dispatch({ type: 'SET_VISITS', payload: res.data })
			})
			.catch((error) => {
				dispatch({ type: 'GET_VISITS_FAIL', payload: error })
			})
	}
}

export const getVisitById = (visitId, _date) => {
	return (dispatch) => {
		dispatch({ type: 'GET_VISIT' })

		return api
			.get(`/visits/${visitId}`)
			.then((res) => {
				dispatch({ type: 'SET_VISIT', payload: res.data })
			})
			.catch((e) => {
				dispatch({ type: 'GET_VISIT_FAIL', payload: e })
			})
	}
}

export const selectVisit = (visitId) => {
	return (dispatch) => {
		dispatch({ type: 'SET_VISIT', payload: visitId })
	}
}

export const updateVisitAddOns = (addOn) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_VISIT_ADD_ONS' })

		return api
			.post('/addOns', addOn)
			.then((response) => {
				dispatch({ type: 'UPDATE_VISIT_SUCCESS', payload: response.data })
			})
			.catch((error) => {
				dispatch({ type: 'UPDATE_VISIT_ADD_ONS_ERROR', payload: error })
			})
	}
}

export const updateMealAddOns = (updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_MEAL_ADDONS' })

		return api
			.post('/updateMealAddons', updates)
			.then((res) => {
				dispatch({
					type: 'UPDATE_VISIT_SUCCESS',
					payload: res.data
				})
			})
			.catch((e) => {
				dispatch({ type: 'UPDATE_VISIT_ADD_ONS_ERROR', payload: e })
			})
	}
}

export const updatePetVisitAssignments = (updates) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_VISIT_ASSIGNMENTS' })

		return api
			.patch('/visit/petAssignments', updates)
			.then((response) => {
				dispatch({
					type: 'UPDATE_VISIT_SUCCESS',
					payload: { visit: response.data.updatedVisit }
				})
				dispatch({
					type: 'UPDATE_FACILITY_SUCCESS',
					payload: { kennels: response.data.kennels }
				})
				if (response?.data?.errors?.length) {
					const error = response?.data?.errors.join(', ').toUpperCase()
					dispatch(showError(`${error} Other assignments were made successfully`))
				} else {
					dispatch(showSuccess('Pet assignments updated successfully.'))
				}
			})
			.catch((error) => {
				dispatch(showError("An error occured while updating this pet's assignments."))
				dispatch({ type: 'UPDATE_VISIT_ASSIGNMENTS_FAILED', payload: error })
			})
	}
}

export const setSelectedFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_FILTERS', payload: filters })
	}
}

export const setSelectedHouseholdFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_HOUSEHOLD_FILTERS', payload: filters })
	}
}

export const clearHouseholdFilters = () => {
	return (dispatch) => {
		dispatch({ type: 'CLEAR_HOUSEHOLD_FILTERS' })
	}
}

export const setSelectedGroomingFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_GROOMING_FILTERS', payload: filters })
	}
}

export const setSelectedGroomingAssignmentFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_GROOMING_ASSIGNMENT_FILTERS', payload: filters })
	}
}

export const setActivityFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_ACTIVITY_FILTERS', payload: filters })
	}
}

export const setSelectedActivityFilters = (filters) => {
	return (dispatch) => {
		dispatch({ type: 'SET_SELECTED_ACTIVITY_FILTERS', payload: filters })
	}
}

export const addToDropoffPickupQueue = async (
	{ visit_id, type, parking_spot, needs_assistance_with_dropoff_medications = false },
	dispatch
) => {
	try {
		const response = await api.post(`/visits/${visit_id}/addVisitToDropoffPickupQueue`, {
			type,
			parking_spot,
			needs_assistance_with_dropoff_medications
		})
		dispatch(showSuccess("Added to I'm Here Queue!"))
		return response
	} catch (e) {
		dispatch(showError(e?.data || 'An error occured while adding this visit to the queue.'))
		return null
	}
}
